module.exports = require('./providerOfIsClass')('Array');
